module.exports = "//static.hsappstatic.net/react-codemirror/static-1.6103/theme/hubspot-canvas-dark.sass"